import { Content, Secondary, Stack, Text } from '@kinesis/bungle';
import { noop } from 'lodash/fp';
import { OrganisationExportItem } from './organisation-export-item';
import { Layout } from '@/components/layout';
import { Loading } from '@/components/loading';
import type { OrganisationExport } from '@/api/exports';

const partKey = (exportId: string, n: number) => `${exportId}:${n}`;

const OrganisationExports = (props: OrganisationExportsProps) => {
  const {
    exports = [],
    isLoading = false,
    downloading = [],
    unavailable = [],
    onDownload = noop,
  } = props;

  return (
    <Layout variant='narrow'>
      <Content>
        <Stack space='medium'>
          <Text>
            Data exports contain a copy of your organisation&rsquo;s files.
          </Text>
          {isLoading ? (
            <Loading />
          ) : exports.length === 0 ? (
            <Text>
              <Secondary>No exports. Contact support to request one.</Secondary>
            </Text>
          ) : (
            <Stack space='large'>
              {exports.map((organisationExport) => (
                <OrganisationExportItem
                  key={organisationExport.id}
                  organisationExport={organisationExport}
                  downloadingParts={organisationExport.parts
                    .map(({ n }) => n)
                    .filter((n) =>
                      downloading.includes(partKey(organisationExport.id, n)),
                    )}
                  unavailable={unavailable.includes(organisationExport.id)}
                  onDownload={onDownload}
                />
              ))}
            </Stack>
          )}
        </Stack>
      </Content>
    </Layout>
  );
};

export type OrganisationExportsProps = {
  exports?: OrganisationExport[];
  isLoading?: boolean;
  // The parts whose links are being generated, as `<export id>:<n>`.
  downloading?: string[];
  // Exports freight answered as gone when a download was asked for.
  unavailable?: string[];
  onDownload?: (exportId: string, n: number) => void;
};

export { OrganisationExports, partKey };
